import { isString } from "../../commons/utils"
import { COUNTING_IGNORED_ELEMENT_TYPES } from "../admin/forms/AdminFormCreationAddableElements"

/**
 * Determines the question number for an element in a row. Skips all the ignored element types in the counting.
 * @param row - Array of row elements
 * @param element - Current element to get the index of
 * @param offset - Offset applied form previous rows and ignored elements
 * @returns {number}
 */
export function findQuestionNumberForElement(row, element, offset) {
  const index = row
    .filter(({ type }) => !COUNTING_IGNORED_ELEMENT_TYPES.includes(type))
    .findIndex(({ id }) => element.id === id)
  if (index === -1) {
    return undefined
  }

  return index + 1 + offset
}

export function getOffset(rows, index) {
  if (!rows) {
    return undefined
  }
  let offset = 0
  for (let i = 0; i < index; i++) {
    const row = rows[i]
    offset += row.filter(
      (elem) => !COUNTING_IGNORED_ELEMENT_TYPES.includes(elem.type)
    ).length
  }
  return offset
}

/**
 * "rows" should be an array of strings|string[] (i.e. ["text-1", ["address-1", "mail-1"], ["phone-1"]]
 * This function will transform those ids into the expected form elements
 * */
export function transformRowsIdsToRowsElements(rows, formElementsMap) {
  return rows.reduce((acc, row, rowOriginalIndex) => {
    // "rowOriginalIndex" is used for update purposes, we lose the original index in <FormRow> and this prevents useless processings
    if (!Array.isArray(row) && !isString(row)) {
      return acc
    }
    if (isString(row)) {
      // Current row is a unique element, so, it's only a id
      const elemId = row
      const element = { ...formElementsMap[elemId], rowOriginalIndex }
      if (element) {
        acc.push(element)
      }
      return acc
    }
    const rowElements = row
      .map(
        (elemId) =>
          formElementsMap[elemId] && {
            ...formElementsMap[elemId],
            rowOriginalIndex
          }
      )
      .filter((e) => e)
    if (rowElements.length > 0) {
      acc.push(rowElements)
    }
    return acc
  }, [])
}

export function compareRows(a, b) {
  if (a.length !== b.length) {
    return false
  }
  return a.some((value, index) => value.localeCompare(b[index]) === 0)
}
